<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      no-padding
      :visible.sync="modalVisible"
      size="800_auto">
    <template #header>
      <span>设置显示字段</span>
    </template>
    <template #content>
      <el-row>
        <el-col :span="leftRow" class="left-col">
          <span class="model-title">所有显示字段</span>
          <el-checkbox-group
              class="gj-checkbox-group"
              v-model="checkList">
            <el-row>
              <template v-for="item in columnData">
                <template v-if="item.children && item.children.length > 0">
                  <el-col
                      v-for="childItem in item.children"
                      :key="childItem.id"
                      :span="8"
                      class="gj-checkbox">
                    <el-checkbox
                        :label="childItem.id"
                        :disabled="childItem.disabled"
                        :checked="childItem.checked">
                      {{childItem.name}}
                    </el-checkbox>
                  </el-col>
                </template>
                <template v-else>
                  <el-col
                      v-if="(isMeaningless(item.permission) || $permission(item.permission)) && (isMeaningless(item.exist) || item.exist)"
                      :key="item.id"
                      :span="8"
                      class="gj-checkbox">
                    <el-checkbox
                        :label="item.id"
                        :disabled="item.disabled"
                        @change="changeCheckState($event,item.id)"
                        :checked="item.checked">
                      {{item.customName || item.name}}
                    </el-checkbox>
                  </el-col>
                </template>
              </template>
            </el-row>
          </el-checkbox-group>

          <!-- 特殊字段， START -->
          <template v-if="groups.length">
          <span class="model-title">特殊字段（{{specialTitle}}）</span>
            <el-checkbox-group
                class="gj-checkbox-group"
                v-model="specialCheckList">
              <el-row>
                <el-col
                    v-for="item in specialCloumn"
                    :key="item"
                    :span="8"
                    class="gj-checkbox">
                  <el-checkbox
                      :label="item"
                      >
                    {{item}}
                  </el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </template>
          <!-- 特殊字段， END -->

        </el-col>
        <el-col :span="rightRow" class="right-col" v-show="showSort">
          <span class="model-title">当前选中字段及顺序</span><br>
          <span class="model-title-tips">可选中拖拽调整顺序</span>
          <ul id="sortColumns">
           <li v-for="item in sortData" :key="item.id" v-show="(isMeaningless(item.permission) || $permission(item.permission)) && item.checked && item.exist !== false"
               :class="{sort_li:!item.disabled && item.fixed !=='left' && item.fixed !=='right',fixed_li:item.disabled || item.fixed ==='left' || item.fixed ==='right'}">
             <span>
               <gj-icon iconfont="icontuozhuai"></gj-icon>
               {{item.customName || item.name}}
             </span>
              <span @click="cancelChecked(item.id)" v-if="!item.disabled">
                <i class="el-icon-close"></i>
              </span>
           </li>
        </ul>
        </el-col>
      </el-row>
    </template>
    <template #footer>
      <gj-button
          @click="cancel">
        取消
      </gj-button>
      <gj-button
          :loading="resetLoading"
          @click="reset">
        恢复默认设置
      </gj-button>
      <gj-button
          :loading="confirmLoading"
          type="primary"
          @click="confirm">
        确定
      </gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {saveCustomColumns} from "../../../api/common";
  import {isMeaninglessMixin, modalMixIn} from "../../../minxins";
  import {isMeaningless} from "../../../utils/common";
  import Sortable from "sortablejs";
  import { remove, uniq } from 'lodash';
  import { SPECIAL_COLUMN } from '../index.js';

  const specialCloumn = Object.values(SPECIAL_COLUMN);
  // console.log('specialCloumn', specialCloumn)

  export default {
    name: "gj-setting-modal",
    mixins: [modalMixIn, isMeaninglessMixin],
    props: {
      columns: {
        type: Array,
        required: true
      },
      sortColumns: {
        type: Array,
        default: () => []
      },
      columnsServer: {
        type: Array,
        default: () => []
      },
      name: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        checkList: [],
        specialCheckList: [],
        sortData:[],
        specialTitle: '',
        specialCloumn,
        columnData: [],
        resetLoading: false,
        confirmLoading: false,
        showSort:true,
        title:"所有可选字段",
        leftRow:17,
        rightRow:7
      }
    },
    computed: {
      groups() {
        return this.columns.filter(e => e.group);
      }
    },
    mounted(){
      this.columnData = this.columns.filter(e => !e.group);

      if (this.groups.length) {
        this.initGroupColumns();
      }

      if(this.sortColumns.length>0){
        this.initSortColumns();
      }
      let blackName = ['financeProfitReportMsku_v1.8.0','financeProfitReportAsin_v1.8.0','financeProfitReportParentAsin_v1.8.0',
        'financeProfitReportSku_v1.8.0','financeProfitReportCategory_v1.8.0','financeProfitReportMarket_v1.8.0','dashboard-sale-instant-table-3.1.1'];
      if(blackName.includes(this.name)){
         this.showSort = false;
         this.title = "所有可选字段";
         this.leftRow = 24
      }
    },
    methods: {
      // 勾选列
      changeCheckState(event,val){
        this.sortData.forEach(item=>{
          if(item.id === val){
            item.checked = event;
          }
        })
        if(event){
          let newIndex = this.columns.findIndex(column=> val === column.id);  // 找到左边的位置
          let preId = '';
          let initData = this._.cloneDeep(this.columns);
          initData.forEach(item=>{
            if(this.checkList.findIndex(id => id === item.id) !== -1){
              item.checked = true;
            }
          })
          if(newIndex > 0){
             for(let i = newIndex-1; i > 0; i--){
                if(initData[i].checked && initData[i].exist !== false){
                   preId = initData[i].id;
                   break;
                }
             }
          }
          if(preId){
            newIndex =  this.sortData.findIndex(column=> preId === column.id);  // 找到右边最新的位置
            newIndex ++; // 放到下一个位置
          }
          let oldIndex =  this.sortData.findIndex(column=> val === column.id);   // 老位置
          if(newIndex !== -1 && oldIndex !== -1) {
            const val = this.sortData[oldIndex];
            this.sortData.splice(oldIndex, 1);
            this.sortData.splice(newIndex, 0, val);
          }
        }

      },
      // 点击 X 事件
      cancelChecked(val){
        this.checkList = this.checkList.filter(item=> item !== val);
        this.sortData.forEach(item=>{
           if(item.id === val){
              item.checked = false;
           }
        })
      },
      // 初始化排序
      initSortColumns(){
         setTimeout(()=>{
          let sortColumns = document.getElementById('sortColumns');
           this.sortData = this._.cloneDeep(this.sortColumns.filter(e => !e.group));
           this.sortable = Sortable.create(sortColumns, {
             animation: 500,
             draggable: ".sort_li", // 可以被拖动的区域
             filter:".fixed_li", // 禁止被拖动
             onEnd: ({newIndex, oldIndex }) => {
               const val = this.sortData[oldIndex]
               this.sortData.splice(oldIndex, 1)
               this.sortData.splice(newIndex, 0, val);
             },
           })
        },10)
      },
      cancel() {
        this.$gjModal.$gjDestroy();
      },
      reset() {
        this.resetLoading = true;
        const columns = this.columns.filter(e => e.default).map(e => e.id);
        saveCustomColumns(this.getConfirmParams(columns))
          .then(() => {
            this.$message.success('保存成功');
            this.$emit('check-list', this.resetColumns(columns));
            this.$gjModal.$gjDestroy();
          })
          .complete(() => this.resetLoading = false);
      },
      confirm() {
        let checkList =[];
        if(this.sortData.length === 0){
          checkList = this.checkList;
        }else{
          checkList = this.sortData.filter(i => i.checked).map(e => e.id);
        }
        if (isMeaningless(checkList) || checkList.length === 0) {
          this.$gjMessage.error('至少勾选一列进行展示！');
          return;
        }
        this.confirmLoading = true;
        saveCustomColumns(this.getConfirmParams(checkList || []))
          .then(() => {
            this.$message.success('保存成功');
            this.$emit('check-list', checkList);
            this.$gjModal.$gjDestroy();
          })
          .complete(() => this.confirmLoading = false);
      },
      // 重置排序
      resetColumns(columns){
        let originColumns = this.columns;
        originColumns.forEach((item,i)=>{
          let index =  columns.findIndex(column=> item === column.id);
          if(index !== -1){
            const val = columns[index];
            columns.splice(index, 1);
            columns.splice(i, 0, val);
          }
        })
        return columns;
      },

      // 初始化特殊字段数据
      initGroupColumns() {
        const { groups } = this;
        // 1. 特殊字段勾选
        const checkbox = [];
        groups.forEach(item => {
          const { id, group } = item;
          if (this.columnsServer.includes(id)) {
            checkbox.push(group.label);
          }
        })
        this.specialCheckList = uniq(checkbox);
        
        // 2.特殊字段标题
        const names = [];
        groups.forEach(i => {
          const find = this.columnData.find(e => i.group?.id === e.id);
          if (find) {
            names.push(find.name)
          }
        })
        this.specialTitle = uniq(names).join(',');
      },

      // saveCustomColumns 接口请求的参数拼接
      getConfirmParams(list) {
        // 分组的特殊字段（sessions和PV），不显示在 UI 上，但需要传到后端保存
        const { groups } = this;
        if (groups.length) {
          const addGroups = [];
          for (let i = 0; i < groups.length; i++) {
            const item = groups[i];
            const { id, group } = item;
            if ( list.includes(group.id) && this.specialCheckList.includes(group.label) ) {
              addGroups.push({id, group}); // 1. 先加进去
            } else {
              remove(list, (i) => i === id)
            }
          }
          // 2. 再排序
          const groupMap = {};
          const groups2 = addGroups.sort((a, b) => {
            return this.specialCheckList.indexOf(b.label) - this.specialCheckList.indexOf(a.label);
          })
          groups2.forEach(item => {
            const { id, group } = item;
            const a = groupMap[group.id] || [];
            a.push(id);
            groupMap[group.id] = a;
          })
          Object.entries(groupMap).forEach(([key, value]) => {
            list.splice(list.indexOf(key) + 1, 0, ...value)
          })
        }
        return {
          module: this.name,
          columns: list.join(',')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gj-checkbox-group {
    padding: 10px;
  }
  .gj-checkbox {
    margin: 6px 0;
  }
  .model-title{
      padding-left: 10px;
      font-weight: bold;
      font-size: 13px;
      color: #333;
  }
  .model-title-tips{
    display: inline-block;
    font-size: 12px;
    padding-left: 10px;
    margin-top: 5px;
    color:#C0C4CC;
  }
  /deep/ .el-dialog__body{
     overflow: hidden;
    font-size: 13px;
  }
  .left-col{
    height: 496px;
    overflow:auto;
    padding-top: 12px;
    padding-left: 10px;
  }
  .right-col{
    border-left:1px solid #EEEEEE;
    height: 496px;
    overflow:auto;
    padding: 12px 12px 20px 0;
  }
  .fixed_li{
     color:#C0C4CC;
  }
  .right-col ul{
    list-style-type: none;
    margin-left: -30px;
    cursor: pointer;
  }
  .right-col li{
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
    padding-bottom: 8px;
  }
  .right-col li:last-child{
    padding-bottom: 6px;
  }
  /deep/ .el-alert--success {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    background-color: rgb(229, 240, 255);
    border-radius: 2px;
    border: 1px solid rgb(151, 199, 255);
  }
  /deep/ .gj-modal--custom .el-dialog {
    height: 600px;
    width: 800px;
  }
  @media (max-height: 768px) {
    /deep/ .gj-modal--custom .el-dialog {
      height: 580px;
      width: 800px;
    }
  }
  /deep/ .sortable-chosen{
    // color: red;
  }
</style>
